import { formatMoney, formatPercent } from "@justhome/common";
import { ApplicationType, OfferPreview } from "@justhome/api-core";
import { FC } from "react";
import { Locale, render } from "../lib/i18n";
import { offerLabels } from "../lib/labels";

interface OfferLegalNoticePopoverProps {
  offer?: OfferPreview;
  applicationType?: ApplicationType;
  locale: Locale;
}
const OfferLegalNoticePopover: FC<OfferLegalNoticePopoverProps> = ({
  offer,
  applicationType,
  locale,
}) => {
  const labels = offerLabels[locale];
  const legalNotice = offer?.loans?.map((currentOffer) => {
    const loanTermYears = Math.floor(
      (currentOffer.totalDurationInMonths || 0) / 12,
    );
    const loanTermMonths = (currentOffer.totalDurationInMonths || 0) % 12;

    const dept =
      applicationType === "FINANCE_ADDITIONAL_COSTS"
        ? labels.maybeDebt
        : labels.debt;

    // fixedInterestPeriodInYears can come "0" from the backend, then we don't need to show it to the user
    const fixedInterestPeriodInYears = currentOffer.fixedInterestPeriodInYears
      ? render(labels.fixedInterestPeriod, {
          fixedInterestPeriodInYears: String(
            currentOffer.fixedInterestPeriodInYears,
          ),
        })
      : null;

    return render(labels.legalNotice, {
      productProviderName: currentOffer.loanProvider?.name,
      interestRate: formatPercent(currentOffer.interestRate || 0, locale),
      effectiveInterest: formatPercent(
        currentOffer.effectiveInterestRate || 0,
        locale,
      ),
      fixedInterestPeriodInYears: fixedInterestPeriodInYears,
      loanAmount: formatMoney(currentOffer.loanAmount || 0, true, locale),
      totalDuration: String(currentOffer.totalDurationInMonths || 0),
      loanTermYears,
      loanTermMonths: String(loanTermMonths),
      monthlyInstallment: formatMoney(
        currentOffer.monthlyInstallment || 0,
        true,
        locale,
      ),
      totalCost: formatMoney(currentOffer.totalCost || 0, true, locale),
      dept,
    });
  });

  if (!legalNotice) {
    return null;
  }

  return (
    <>
      {legalNotice.map((notice, index) => {
        return (
          <div key={index} className="mb-2">
            <span>{notice}</span>
          </div>
        );
      })}
    </>
  );
};

export default OfferLegalNoticePopover;
